var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content"
  }, [_c('back-button'), _c('div', {
    staticClass: "title"
  }, [_vm._v(" " + _vm._s(_vm.$store.state.wifiStatus.connected ? "Connected to:" : "Last connected to:") + " ")]), _c('green-border-box', {
    attrs: {
      "data-tn": "ssid"
    }
  }, [_vm._v(" " + _vm._s(_vm.$store.state.wifiStatus.ssid) + " ")]), _c('div', {
    staticClass: "wifi-status"
  }, [_vm.$store.state.wifiStatus.connected ? _c('WifiOkSVG', {
    attrs: {
      "data-tn": "ok"
    }
  }) : _c('WifiNoGoodSVG', {
    attrs: {
      "data-tn": "no-good"
    }
  })], 1), _c('div', {
    staticClass: "divider"
  }), _c('div', [_c('a', {
    attrs: {
      "href": "//info.allumeenergy.com/hubfs/ANZ%20-%20Customer%20facing%20documents/0339_Changing-Wi-Fi-credentials_AUS.pdf",
      "target": "_blank"
    }
  }, [_c('a-row', {
    staticClass: "green-box",
    attrs: {
      "type": "flex",
      "align": "middle"
    }
  }, [_c('a-col', {
    attrs: {
      "span": 6
    }
  }, [_c('InfoCentreSVG')], 1), _c('a-col', {
    attrs: {
      "span": 18
    }
  }, [_vm._v(" How to change Wi-Fi network ")])], 1)], 1)]), _c('back-button')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }